(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9832,6790],{

/***/ 25456:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welcome",
      function () {
        return __webpack_require__(7654);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8303);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3949);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function PrimaryButton(param) {
    let { children , disabled , onClick , type ="button" , icon , loading =false , size ="medium" , id , fullWidth =true , rounded =true , danger =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        id: id,
        type: type,
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().primaryBtn), " ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], " ").concat(disabled ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : "", " ").concat(fullWidth ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullWidth) : "", " ").concat(rounded ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rounded) : "", " ").concat(danger ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().danger) : ""),
        disabled: disabled || loading,
        onClick: onClick,
        children: !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon ? icon : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                    children: children
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: 22
        })
    });
}


/***/ }),

/***/ 80869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FallbackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50937);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71415);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @next/next/no-img-element */ 



function FallbackImage(param) {
    let { src , alt ="image" , onError , style , fill , width , height , ...props } = param;
    const isValidSrc = src && (src.startsWith("/") || src.startsWith("http://") || src.startsWith("https://"));
    if (!isValidSrc) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        ...props,
        style: style,
        src: src,
        alt: alt,
        title: alt,
        fill: fill,
        width: width,
        height: height,
        className: (_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default().root),
        onError: (e)=>{
            e.target.style.visibility = "hidden";
            onError === null || onError === void 0 ? void 0 : onError(e);
        }
    });
}


/***/ }),

/***/ 39415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Price; }
});

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23934);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(59108);
// EXTERNAL MODULE: ./hooks/useRedux.tsx
var useRedux = __webpack_require__(62475);
// EXTERNAL MODULE: ./redux/slices/currency.ts
var slices_currency = __webpack_require__(2201);
;// CONCATENATED MODULE: ./utils/numberToPrice.ts
const numberToPrice = function(number) {
    let digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    if (number) {
        return number.toFixed(digits).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    }
    return "0";
};

;// CONCATENATED MODULE: ./components/price/price.tsx





function Price(param) {
    let { number =0 , minus , symbol , plus , digits , old  } = param;
    const currency = (0,useRedux/* useAppSelector */.C)(slices_currency/* selectCurrency */.j);
    const position = (currency === null || currency === void 0 ? void 0 : currency.position) || "before";
    const currencySymbol = symbol || (currency === null || currency === void 0 ? void 0 : currency.symbol) || "$";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "".concat(minus ? "red" : "", " ").concat(old ? "strike" : ""),
        children: [
            minus ? "-" : "",
            plus ? "+" : "",
            position === "before" ? currencySymbol : "",
            numberToPrice(number, digits),
            position === "after" ? currencySymbol : ""
        ]
    });
}


/***/ }),

/***/ 76790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProfileDropdown; }
});

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23934);
// EXTERNAL MODULE: ./components/profileDropdown/profileDropdown.module.scss
var profileDropdown_module = __webpack_require__(2960);
var profileDropdown_module_default = /*#__PURE__*/__webpack_require__.n(profileDropdown_module);
// EXTERNAL MODULE: ./containers/popover/popover.tsx
var popover = __webpack_require__(40341);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(36291);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(82807);
// EXTERNAL MODULE: ./hooks/usePopover.tsx
var usePopover = __webpack_require__(82986);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(59108);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(80869);
// EXTERNAL MODULE: ./utils/getAvatar.ts
var getAvatar = __webpack_require__(57538);
;// CONCATENATED MODULE: ./utils/getProfileIdentity.ts
function cleanName(value) {
    return typeof value === "string" ? value.normalize("NFC").trim().replace(/\s+/g, " ") : "";
}
function getProfileIdentity(data, fallbackName) {
    const name = [
        cleanName(data === null || data === void 0 ? void 0 : data.firstname),
        cleanName(data === null || data === void 0 ? void 0 : data.lastname)
    ].filter(Boolean).join(" ") || cleanName(data === null || data === void 0 ? void 0 : data.fullName) || cleanName(data === null || data === void 0 ? void 0 : data.name);
    const parts = name.split(" ").filter(Boolean);
    const first = Array.from(parts[0] || "")[0] || "";
    const last = parts.length > 1 ? Array.from(parts[parts.length - 1])[0] : "";
    return {
        name: name || fallbackName,
        initials: (first + last).toLocaleUpperCase() || "?"
    };
}
// Keep the same public image hosts/protocol as next.config.js. A malformed or
// unsupported profile URL is missing media, not a reason to lose account access.
function getProfilePhotoSource(value, hosts, protocol) {
    if (typeof value !== "string" || !value.trim()) return null;
    const source = value.trim();
    if (source.startsWith("/") && !source.startsWith("//")) return source;
    try {
        const url = new URL(source);
        return (url.protocol === "http:" || url.protocol === "https:") && url.protocol === "".concat(protocol, ":") && !url.username && !url.password && hosts.some((host)=>host && host.toLowerCase() === url.hostname.toLowerCase()) ? source : null;
    } catch (e) {
        return null;
    }
}

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/CloseLineIcon.js
var CloseLineIcon = __webpack_require__(85823);
var CloseLineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseLineIcon);
// EXTERNAL MODULE: ./components/profileDropdown/profileDropdownLinks.tsx
var profileDropdownLinks = __webpack_require__(23244);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(92879);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/LogoutCircleRLineIcon.js
var LogoutCircleRLineIcon = __webpack_require__(84686);
var LogoutCircleRLineIcon_default = /*#__PURE__*/__webpack_require__.n(LogoutCircleRLineIcon);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/Wallet3LineIcon.js
var Wallet3LineIcon = __webpack_require__(45787);
var Wallet3LineIcon_default = /*#__PURE__*/__webpack_require__.n(Wallet3LineIcon);
// EXTERNAL MODULE: ./components/price/price.tsx + 1 modules
var price = __webpack_require__(39415);
// EXTERNAL MODULE: ./utils/getNearestFloor.ts
var getNearestFloor = __webpack_require__(59858);
;// CONCATENATED MODULE: ./components/profileDropdown/profileDropdown.tsx

















function ProfileAvatar(param) {
    let { data , initials  } = param;
    const [failedSource, setFailedSource] = (0,react.useState)(null);
    const resolvedSource = typeof (data === null || data === void 0 ? void 0 : data.img) === "string" && data.img.trim() ? (0,getAvatar/* default */.Z)(data.img.trim()) : null;
    const source = getProfilePhotoSource(resolvedSource, [
        "api.storelisted.com",
        "s3extlink.s3.us-east-1.amazonaws.com"
    ], "https");
    return source && source !== failedSource ? /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
        fill: true,
        src: source,
        alt: "",
        sizes: "60px",
        onError: ()=>setFailedSource(source)
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (profileDropdown_module_default()).initials,
        "aria-hidden": "true",
        children: initials
    });
}
function ProfileDropdown(param) {
    let { data  } = param;
    var ref;
    const { t  } = (0,es/* useTranslation */.$G)();
    const [open, anchorEl, handleOpen, handleClose] = (0,usePopover/* default */.Z)();
    const { logout , isAuthenticated , openAuthModal , openWalletHistory , user  } = (0,auth_context/* useAuth */.a)();
    const identity = getProfileIdentity(data, t("profile"));
    const handleLogout = ()=>{
        logout();
        handleClose();
    };
    const actualLinks = !isAuthenticated ? profileDropdownLinks/* profileDropdownLinks.filter */.a.filter((item)=>!item.requiredAuth) : profileDropdownLinks/* profileDropdownLinks */.a;
    if (!isAuthenticated) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: (profileDropdown_module_default()).login,
            onClick: ()=>openAuthModal(),
            children: t("login")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: (profileDropdown_module_default()).profileBtn,
                onClick: handleOpen,
                "aria-label": identity.name,
                "aria-expanded": open,
                title: identity.name,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (profileDropdown_module_default()).imgWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar, {
                            data: data,
                            initials: identity.initials
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (profileDropdown_module_default()).profileName,
                        children: identity.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover["default"], {
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: 40
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (profileDropdown_module_default()).wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (profileDropdown_module_default()).closeIcon,
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseLineIcon_default()), {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                            className: (profileDropdown_module_default()).header,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (profileDropdown_module_default()).profileImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar, {
                                        data: data,
                                        initials: identity.initials
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (profileDropdown_module_default()).naming,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/profile",
                                        className: (profileDropdown_module_default()).title,
                                        children: identity.name
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (profileDropdown_module_default()).body,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: (profileDropdown_module_default()).flex,
                                    onClick: ()=>{
                                        handleClose();
                                        openWalletHistory();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((Wallet3LineIcon_default()), {
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (profileDropdown_module_default()).text,
                                            children: [
                                                t("wallet"),
                                                ":",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (profileDropdown_module_default()).price,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(price/* default */.Z, {
                                                        number: (0,getNearestFloor/* getNearestFloor */.n)(user === null || user === void 0 ? void 0 : (ref = user.wallet) === null || ref === void 0 ? void 0 : ref.price)
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, "wallet"),
                                actualLinks.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                        href: item.href,
                                        className: (profileDropdown_module_default()).flex,
                                        onClick: handleClose,
                                        children: [
                                            item.icon,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (profileDropdown_module_default()).text,
                                                children: t(item.label)
                                            })
                                        ]
                                    }, item.href)),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: (profileDropdown_module_default()).flex,
                                    onClick: handleLogout,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((LogoutCircleRLineIcon_default()), {
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (profileDropdown_module_default()).text,
                                            children: t("logout")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 23244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ profileDropdownLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58752);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86712);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29915);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11042);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30329);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75958);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90643);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93292);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__);









const profileDropdownLinks = [
    {
        label: "shops",
        href: "/shop",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "order.history",
        href: "/orders",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "refund.orders",
        href: "/orders/refunds",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "liked.shops",
        href: "/liked/shops",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "liked.products",
        href: "/liked/products",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "viewed.products",
        href: "/product/viewed",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "profile.settings",
        href: "/profile",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "site.settings",
        href: "/settings",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
            size: 24
        }),
        requiredAuth: false
    }
];


/***/ }),

/***/ 12651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51834);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34741);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30300);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85286);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 40341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PopoverContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47966);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90274);




const Wrapper = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((param)=>{
    let { customStyles  } = param;
    return {
        "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0)"
        },
        "& .MuiPaper-root": {
            backgroundColor: "var(--secondary-bg)",
            boxShadow: "var(--popover-box-shadow)",
            borderRadius: "25px",
            maxWidth: "100%",
            ...customStyles
        }
    };
});
function PopoverContainer(param) {
    let { children , customStyles , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        customStyles: customStyles,
        ...rest,
        children: children
    });
}


/***/ }),

/***/ 82986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePopover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59108);

function usePopover() {
    const [anchorEl, setAnchorEl] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event)=>{
        return setAnchorEl(event === null || event === void 0 ? void 0 : event.currentTarget);
    };
    const handleClose = ()=>setAnchorEl(null);
    return [
        open,
        anchorEl,
        handleOpen,
        handleClose
    ];
}


/***/ }),

/***/ 7654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Welcome; }
});

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23934);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(59108);
// EXTERNAL MODULE: ./components/seo.tsx
var seo = __webpack_require__(12651);
// EXTERNAL MODULE: ./containers/welcome/welcome.module.scss
var welcome_module = __webpack_require__(62353);
var welcome_module_default = /*#__PURE__*/__webpack_require__.n(welcome_module);
// EXTERNAL MODULE: ./contexts/theme/theme.context.tsx
var theme_context = __webpack_require__(50140);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react-query@3.39.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-query/es/index.js
var es = __webpack_require__(65084);
// EXTERNAL MODULE: ./services/information.ts
var information = __webpack_require__(97535);
// EXTERNAL MODULE: ./contexts/settings/settings.context.tsx
var settings_context = __webpack_require__(85286);
// EXTERNAL MODULE: ./containers/errorBoundary/errorBoundary.tsx
var errorBoundary = __webpack_require__(44702);
// EXTERNAL MODULE: ./components/welcomeHeader/welcomeHeader.module.scss
var welcomeHeader_module = __webpack_require__(22885);
var welcomeHeader_module_default = /*#__PURE__*/__webpack_require__.n(welcomeHeader_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(36291);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(33733);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(92879);
// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(72526);
// EXTERNAL MODULE: ./components/profileDropdown/profileDropdown.tsx + 1 modules
var profileDropdown = __webpack_require__(76790);
;// CONCATENATED MODULE: ./components/welcomeHeader/welcomeHeader.tsx








function WelcomeHeader() {
    const { t  } = (0,useLocale/* default */.Z)();
    const { openAuthModal , isAuthenticated , user  } = (0,auth_context/* useAuth */.a)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "welcome-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: (welcomeHeader_module_default()).header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (welcomeHeader_module_default()).navItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        className: (welcomeHeader_module_default()).brandLogo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BrandLogo */.Oc, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (welcomeHeader_module_default()).navItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (welcomeHeader_module_default()).actions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/about",
                                className: (welcomeHeader_module_default()).itemLink,
                                children: t("about")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blog",
                                className: (welcomeHeader_module_default()).itemLink,
                                children: t("blog")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/careers",
                                className: (welcomeHeader_module_default()).itemLink,
                                children: t("careers")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (welcomeHeader_module_default()).navItem,
                    children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(profileDropdown["default"], {
                        data: user
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: openAuthModal,
                        className: (welcomeHeader_module_default()).login,
                        children: t("login")
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./containers/layout/footer/footer.tsx
var footer = __webpack_require__(9605);
;// CONCATENATED MODULE: ./containers/welcome/welcome.tsx










function WelcomeContainer(param) {
    let { children  } = param;
    const { isDarkMode  } = (0,react.useContext)(theme_context/* ThemeContext */.N);
    const { updateSettings  } = (0,settings_context/* useSettings */.r)();
    (0,es.useQuery)("settings", ()=>information/* default.getSettings */.Z.getSettings(), {
        onSuccess: (data)=>{
            const obj = createSettings(data.data);
            updateSettings({
                payment_type: obj.payment_type,
                instagram_url: obj.instagram,
                facebook_url: obj.facebook,
                twitter_url: obj.twitter,
                referral_active: obj.referral_active,
                otp_expire_time: obj.otp_expire_time,
                customer_app_android: obj.customer_app_android,
                customer_app_ios: obj.customer_app_ios,
                delivery_app_android: obj.delivery_app_android,
                delivery_app_ios: obj.delivery_app_ios,
                vendor_app_android: obj.vendor_app_android,
                vendor_app_ios: obj.vendor_app_ios,
                group_order: obj.group_order,
                footer_text: obj.footer_text,
                ui_type: obj.ui_type,
                address_text: obj.address,
                phone: obj.phone,
                email: obj.email,
                reservation_time_durations: obj.reservation_time_durations,
                reservation_before_time: obj.reservation_before_time,
                min_reservation_time: obj.min_reservation_time,
                active_parcel: obj.active_parcel,
                before_order_phone_required: obj.before_order_phone_required,
                reservation_enable_for_user: obj.reservation_enable_for_user,
                google_map_key: obj.google_map_key,
                favicon: obj.favicon,
                title: obj.title,
                generalSettingsLocation: obj.location
            });
        }
    });
    function createSettings(list) {
        const result = list.map((item)=>({
                [item.key]: item.value
            }));
        return Object.assign({}, ...result);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(errorBoundary/* default */.Z, {
        isDarkMode: isDarkMode,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WelcomeHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (welcome_module_default()).body,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {})
        ]
    });
}

// EXTERNAL MODULE: ./components/welcomeHero/welcomeHero.module.scss
var welcomeHero_module = __webpack_require__(16073);
var welcomeHero_module_default = /*#__PURE__*/__webpack_require__.n(welcomeHero_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/Search2LineIcon.js
var Search2LineIcon = __webpack_require__(97367);
var Search2LineIcon_default = /*#__PURE__*/__webpack_require__.n(Search2LineIcon);
// EXTERNAL MODULE: ./components/button/primaryButton.tsx
var primaryButton = __webpack_require__(66868);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/dynamic.js
var dynamic = __webpack_require__(65564);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/router.js
var router = __webpack_require__(49369);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/MapPinRangeLineIcon.js
var MapPinRangeLineIcon = __webpack_require__(87910);
var MapPinRangeLineIcon_default = /*#__PURE__*/__webpack_require__.n(MapPinRangeLineIcon);
// EXTERNAL MODULE: ./constants/config.ts
var config = __webpack_require__(30300);
// EXTERNAL MODULE: ./utils/getAddressFromLocation.ts
var getAddressFromLocation = __webpack_require__(29055);
;// CONCATENATED MODULE: ./utils/roundToHundreds.ts
function roundToHundreds(number) {
    const num = Number(number);
    if (!num) {
        return 0;
    }
    return Math.floor(num / 100) * 100;
}

;// CONCATENATED MODULE: ./utils/getShorterNumber.ts
function getShorterNumber(number) {
    let decPlaces = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, minShorter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!number) {
        return 0;
    }
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = 10 ** decPlaces;
    // Enumerate number abbreviations
    const abbrev = [
        " K",
        " M",
        " B",
        " T"
    ];
    // Go through the array backwards, so we do the largest first
    for(let i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        const size = 10 ** ((i + 1) * 3);
        const minSize = 10 ** minShorter;
        // If the number is bigger or equal do the abbreviation
        if (size <= number && minSize < number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += Number(abbrev[i]);
            break;
        }
    }
    return number;
}
/* harmony default export */ var utils_getShorterNumber = (getShorterNumber);

;// CONCATENATED MODULE: ./components/welcomeHero/welcomeHero.tsx














const Map = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(602), __webpack_require__.e(3885)]).then(__webpack_require__.bind(__webpack_require__, 53885)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(53885)
            ]
    },
    ssr: false
});
function WelcomeHero(param) {
    let { data , stats  } = param;
    const { t , locale  } = (0,useLocale/* default */.Z)();
    const inputRef = (0,react.useRef)();
    const { push  } = (0,router.useRouter)();
    const { updateAddress , updateLocation  } = (0,settings_context/* useSettings */.r)();
    const [location, setLocation] = (0,react.useState)({
        lat: 0,
        lng: 0
    });
    const onSubmit = (event)=>{
        var ref;
        event.preventDefault();
        if (!location.lat && !location.lng) {
            return;
        }
        updateAddress((ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.value);
        updateLocation("".concat(location.lat, ",").concat(location.lng));
        push("/");
    };
    const chooseDefaultAddress = async ()=>{
        const latlng = (config/* DEFAULT_LOCATION */.PX === null || config/* DEFAULT_LOCATION */.PX === void 0 ? void 0 : config/* DEFAULT_LOCATION.split */.PX.split(",")) || [];
        setLocation({
            lat: Number(latlng[0] || 0),
            lng: Number(latlng[1] || 0)
        });
        inputRef.current.value = await (0,getAddressFromLocation/* getAddressFromLocation */.K)(config/* DEFAULT_LOCATION */.PX);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (welcomeHero_module_default()).container,
                style: {
                    backgroundImage: "url(".concat(data === null || data === void 0 ? void 0 : data.img, ")")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "welcome-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (welcomeHero_module_default()).wrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (welcomeHero_module_default()).block,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: (welcomeHero_module_default()).title,
                                    children: data === null || data === void 0 ? void 0 : data.title[locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (welcomeHero_module_default()).caption,
                                    children: data === null || data === void 0 ? void 0 : data.description[locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (welcomeHero_module_default()).searchBar,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            className: (welcomeHero_module_default()).search,
                                            onSubmit: onSubmit,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "search",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Search2LineIcon_default()), {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    id: "search",
                                                    name: "search",
                                                    ref: inputRef,
                                                    placeholder: t("search"),
                                                    autoComplete: "off"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (welcomeHero_module_default()).btnWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                                                onClick: onSubmit,
                                                children: t("ok")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (welcomeHero_module_default()).actions,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: (welcomeHero_module_default()).textButton,
                                        onClick: chooseDefaultAddress,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((MapPinRangeLineIcon_default()), {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (welcomeHero_module_default()).text,
                                                children: t("choose.recomended.address")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (welcomeHero_module_default()).stats,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (welcomeHero_module_default()).item,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (welcomeHero_module_default()).number,
                                                    children: [
                                                        roundToHundreds(stats === null || stats === void 0 ? void 0 : stats.users),
                                                        "+"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (welcomeHero_module_default()).text,
                                                    children: t("people.trust.us")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (welcomeHero_module_default()).item,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (welcomeHero_module_default()).number,
                                                    children: [
                                                        utils_getShorterNumber(roundToHundreds(stats === null || stats === void 0 ? void 0 : stats.orders)),
                                                        "+"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (welcomeHero_module_default()).text,
                                                    children: t("delivery.was.successfull")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
                location: location,
                setLocation: setLocation,
                inputRef: inputRef
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/whyChooseUs/whyChooseUs.module.scss
var whyChooseUs_module = __webpack_require__(49014);
var whyChooseUs_module_default = /*#__PURE__*/__webpack_require__.n(whyChooseUs_module);
;// CONCATENATED MODULE: ./components/whyChooseUs/whyChooseUs.tsx




function WhyChooseUs(param) {
    let { data  } = param;
    const { t , locale  } = (0,useLocale/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (whyChooseUs_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "welcome-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (whyChooseUs_module_default()).wrapper,
                children: [
                    !!(data === null || data === void 0 ? void 0 : data.features.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (whyChooseUs_module_default()).title,
                        children: t("why.choose.us")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (whyChooseUs_module_default()).flex,
                        children: data === null || data === void 0 ? void 0 : data.features.map((item, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (whyChooseUs_module_default()).card,
                                tabIndex: idx + 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (whyChooseUs_module_default()).number,
                                        children: [
                                            "0",
                                            idx + 1
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (whyChooseUs_module_default()).cardTitle,
                                        children: item.title[locale]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (whyChooseUs_module_default()).text,
                                        children: item.description[locale]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                        loop: true,
                                        muted: true,
                                        autoPlay: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                            src: item.img
                                        })
                                    })
                                ]
                            }, idx))
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./services/blog.ts
var services_blog = __webpack_require__(54379);
// EXTERNAL MODULE: ./components/welcomeBlog/welcomeBlog.module.scss
var welcomeBlog_module = __webpack_require__(10515);
var welcomeBlog_module_default = /*#__PURE__*/__webpack_require__.n(welcomeBlog_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(74647);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(80869);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/InstagramLineIcon.js
var InstagramLineIcon = __webpack_require__(8663);
var InstagramLineIcon_default = /*#__PURE__*/__webpack_require__.n(InstagramLineIcon);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/ArrowRightLineIcon.js
var ArrowRightLineIcon = __webpack_require__(72493);
var ArrowRightLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightLineIcon);
;// CONCATENATED MODULE: ./components/welcomeBlog/welcomeBlog.tsx










function WelcomeBlog(param) {
    let { data  } = param;
    const { t  } = (0,useLocale/* default */.Z)();
    const { settings  } = (0,settings_context/* useSettings */.r)();
    if (data) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (welcomeBlog_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "welcome-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (welcomeBlog_module_default()).wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (welcomeBlog_module_default()).header,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (welcomeBlog_module_default()).heading,
                                    children: t("latest.blog")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: "/blog",
                                    className: (welcomeBlog_module_default()).link,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (welcomeBlog_module_default()).text,
                                            children: t("see.all")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightLineIcon_default()), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 8,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (welcomeBlog_module_default()).card,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: (welcomeBlog_module_default()).title,
                                                children: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (welcomeBlog_module_default()).body,
                                                dangerouslySetInnerHTML: {
                                                    __html: (data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.description) && (data === null || data === void 0 ? void 0 : (ref2 = data.translation) === null || ref2 === void 0 ? void 0 : ref2.description.length) > 499 ? "".concat(data === null || data === void 0 ? void 0 : (ref3 = data.translation) === null || ref3 === void 0 ? void 0 : ref3.description.slice(0, 500), "...") : (data === null || data === void 0 ? void 0 : (ref4 = data.translation) === null || ref4 === void 0 ? void 0 : ref4.description) || ""
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: (welcomeBlog_module_default()).link,
                                                href: "/blog/".concat(data === null || data === void 0 ? void 0 : data.uuid),
                                                children: t("read.more")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (welcomeBlog_module_default()).imgWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                                            src: data === null || data === void 0 ? void 0 : data.img,
                                            alt: data === null || data === void 0 ? void 0 : (ref5 = data.translation) === null || ref5 === void 0 ? void 0 : ref5.title,
                                            fill: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: settings === null || settings === void 0 ? void 0 : settings.instagram_url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: (welcomeBlog_module_default()).socialCard,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((InstagramLineIcon_default()), {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (welcomeBlog_module_default()).label,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (welcomeBlog_module_default()).text,
                                                        children: t("view.our.insta")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightLineIcon_default()), {})
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 8,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (welcomeBlog_module_default()).card,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (welcomeBlog_module_default()).badge,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (welcomeBlog_module_default()).text,
                                                    children: t("ads")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: (welcomeBlog_module_default()).title,
                                                children: "Broccoli Bacon Salad"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((welcomeBlog_module_default()).body, " ").concat((welcomeBlog_module_default()).small),
                                                children: [
                                                    "This easy chicken and broccoli casserole is ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " a quick one-skillet dinner fix that's a guaranteed ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " crowd pleaser."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (welcomeBlog_module_default()).float,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                                                    src: "/images/broccoli.png",
                                                    alt: "Broccoli Bacon Salad",
                                                    fill: true
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
}

// EXTERNAL MODULE: ./containers/faq/faq.module.scss
var faq_module = __webpack_require__(24610);
var faq_module_default = /*#__PURE__*/__webpack_require__.n(faq_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/AddLineIcon.js
var AddLineIcon = __webpack_require__(10054);
var AddLineIcon_default = /*#__PURE__*/__webpack_require__.n(AddLineIcon);
;// CONCATENATED MODULE: ./containers/faq/faqItem.tsx




function FaqItem(param) {
    let { data  } = param;
    var ref, ref1;
    const [isOpen, setOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((faq_module_default()).item, " ").concat(isOpen ? (faq_module_default()).active : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (faq_module_default()).header,
                onClick: ()=>setOpen(!isOpen),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (faq_module_default()).label,
                        children: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((AddLineIcon_default()), {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (faq_module_default()).body,
                children: (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.answer
            })
        ]
    });
}

;// CONCATENATED MODULE: ./containers/faq/faq.tsx





function FaqContainer(param) {
    let { data  } = param;
    const { t  } = (0,useLocale/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (faq_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "welcome-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (faq_module_default()).wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (faq_module_default()).title,
                        children: t("faq")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (faq_module_default()).accordion,
                        children: data === null || data === void 0 ? void 0 : data.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FaqItem, {
                                data: item
                            }, item.id))
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./services/faq.ts
var faq = __webpack_require__(58629);
// EXTERNAL MODULE: ./services/page.ts
var page = __webpack_require__(67122);
;// CONCATENATED MODULE: ./pages/welcome.tsx













var __N_SSG = true;
function Welcome(param) {
    let {} = param;
    var ref, ref1;
    const { locale  } = (0,useLocale/* default */.Z)();
    const { data  } = (0,es.useQuery)([
        "landingPage",
        locale
    ], ()=>page/* default.getLandingPage */.Z.getLandingPage());
    const { data: stats  } = (0,es.useQuery)([
        "stats",
        locale
    ], ()=>page/* default.getStatistics */.Z.getStatistics());
    const { data: blog  } = (0,es.useQuery)([
        "lastBlog",
        locale
    ], ()=>services_blog/* default.getLastBlog */.Z.getLastBlog());
    const { data: faqs  } = (0,es.useQuery)([
        "faqs",
        locale
    ], ()=>faq/* default.getAll */.Z.getAll());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WelcomeContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WelcomeHero, {
                        data: data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.data,
                        stats: stats === null || stats === void 0 ? void 0 : stats.data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyChooseUs, {
                        data: data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : ref1.data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WelcomeBlog, {
                        data: blog === null || blog === void 0 ? void 0 : blog.data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqContainer, {
                        data: faqs === null || faqs === void 0 ? void 0 : faqs.data
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 54379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const blogService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/blogs/paginate?type=blog", {
            params
        }),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/blogs/".concat(id), {
            params
        }),
    getLastBlog: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("rest/last-blog/show", {
            params
        }),
    getAllNews: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/blogs/paginate?type=notification", {
            params
        }),
    getNewsById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/blogs/".concat(id), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (blogService);


/***/ }),

/***/ 58629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const faqService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/faqs/paginate", {
            params
        }),
    getPrivacy: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/policy", {
            params
        }),
    getTerms: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/term", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (faqService);


/***/ }),

/***/ 67122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const pageService = {
    getDeliverPage: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/pages/delivery", {
            params
        }),
    getAboutPage: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/pages/about", {
            params
        }),
    getAboutSections: ()=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/pages/paginate?page=1&perPage=10&type=all_about"),
    getLandingPage: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/landing-pages/welcome", {
            params
        }),
    getStatistics: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/stat", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (pageService);


/***/ }),

/***/ 29055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getAddressFromLocation; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72771);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34741);


async function getAddressFromLocation(latlng) {
    let params = {
        latlng,
        key: constants_constants__WEBPACK_IMPORTED_MODULE_0__/* .MAP_API_KEY */ .kr
    };
    return axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("https://maps.googleapis.com/maps/api/geocode/json", {
        params
    }).then((param)=>{
        let { data  } = param;
        var ref;
        return (ref = data.results[0]) === null || ref === void 0 ? void 0 : ref.formatted_address;
    }).catch((error)=>{
        console.log(error);
        return "not found";
    });
}


/***/ }),

/***/ 57538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getAvatar; }
/* harmony export */ });
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34741);

const avatar_placeholder = "/images/avatar_placeholder.png";
function getAvatar(img) {
    if (img) {
        return img.includes("http") ? img : constants_constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_URL */ .yA + img;
    } else {
        return avatar_placeholder;
    }
}


/***/ }),

/***/ 59858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ getNearestFloor; }
/* harmony export */ });
function getNearestFloor(number) {
    return Math.floor((number || 0) * 100) / 100;
}


/***/ }),

/***/ 50937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"fallbackImage_root__7qEqB"};

/***/ }),

/***/ 2960:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profileBtn":"profileDropdown_profileBtn__lUVki","imgWrapper":"profileDropdown_imgWrapper__6btm2","profileName":"profileDropdown_profileName__AsUk2","initials":"profileDropdown_initials__MMmCO","login":"profileDropdown_login__iC6C_","wrapper":"profileDropdown_wrapper__GR3_r","closeIcon":"profileDropdown_closeIcon__QmpuM","header":"profileDropdown_header__rbpis","naming":"profileDropdown_naming__3WG7e","title":"profileDropdown_title__ythS3","profileImage":"profileDropdown_profileImage__HL_Z_","body":"profileDropdown_body__Tqeyo","flex":"profileDropdown_flex__pAYIs","text":"profileDropdown_text__CCJs4","price":"profileDropdown_price__7biJh","badge":"profileDropdown_badge__wjFQg"};

/***/ }),

/***/ 10515:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"welcomeBlog_container__y6S2h","wrapper":"welcomeBlog_wrapper__KbPnV","imgWrapper":"welcomeBlog_imgWrapper__66zxU","header":"welcomeBlog_header__4t6DY","heading":"welcomeBlog_heading__2Fk3f","link":"welcomeBlog_link__ohilf","text":"welcomeBlog_text__poL0F","card":"welcomeBlog_card__BSgQN","title":"welcomeBlog_title__CXb2C","body":"welcomeBlog_body__b5jRI","small":"welcomeBlog_small__82U1X","float":"welcomeBlog_float___fDdl","badge":"welcomeBlog_badge__12vEa","socialCard":"welcomeBlog_socialCard__ju7Xo","label":"welcomeBlog_label__VeAhY"};

/***/ }),

/***/ 22885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"welcomeHeader_header__W0dt6","navItem":"welcomeHeader_navItem__HT6UE","brandLogo":"welcomeHeader_brandLogo__9VGOU","menuBtn":"welcomeHeader_menuBtn__P68b0","login":"welcomeHeader_login__8PDUP","searchBar":"welcomeHeader_searchBar__w4c58","actions":"welcomeHeader_actions__6AIyc","itemLink":"welcomeHeader_itemLink__fxTTB"};

/***/ }),

/***/ 16073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"welcomeHero_container__9pjs8","wrapper":"welcomeHero_wrapper__DwYEy","block":"welcomeHero_block__ytj16","title":"welcomeHero_title__1sS8K","caption":"welcomeHero_caption__hHMNy","searchBar":"welcomeHero_searchBar__w5Li7","search":"welcomeHero_search__Ciw_C","btnWrapper":"welcomeHero_btnWrapper__tPlRB","actions":"welcomeHero_actions__33DX8","textButton":"welcomeHero_textButton__gSIxd","text":"welcomeHero_text__VytOH","stats":"welcomeHero_stats__A5YAB","item":"welcomeHero_item__2BztM","number":"welcomeHero_number__HPfbA"};

/***/ }),

/***/ 49014:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"whyChooseUs_container__slc__","wrapper":"whyChooseUs_wrapper__8W8_r","title":"whyChooseUs_title__CAGVp","flex":"whyChooseUs_flex__hqVUO","card":"whyChooseUs_card__TAJSM","number":"whyChooseUs_number__su9RD","cardTitle":"whyChooseUs_cardTitle__2U4eQ","text":"whyChooseUs_text__QDmED"};

/***/ }),

/***/ 24610:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"faq_container__vnQGp","wrapper":"faq_wrapper__PiQ4h","title":"faq_title__CbXm3","accordion":"faq_accordion__Kaq_0","item":"faq_item__OK2MG","header":"faq_header__4NHR5","label":"faq_label__Cpkzw","body":"faq_body__7jCGR","active":"faq_active___S_pn"};

/***/ }),

/***/ 62353:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"body":"welcome_body__7TUQ9"};

/***/ }),

/***/ 51834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(58761)


/***/ }),

/***/ 10054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var AddLineIcon = function AddLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z' })
  );
};

var AddLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(AddLineIcon) : AddLineIcon;

module.exports = AddLineIcon$1;


/***/ }),

/***/ 72493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowRightLineIcon = function ArrowRightLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z' })
  );
};

var ArrowRightLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowRightLineIcon) : ArrowRightLineIcon;

module.exports = ArrowRightLineIcon$1;


/***/ }),

/***/ 85823:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var CloseLineIcon = function CloseLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z' })
  );
};

var CloseLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(CloseLineIcon) : CloseLineIcon;

module.exports = CloseLineIcon$1;


/***/ }),

/***/ 87910:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var MapPinRangeLineIcon = function MapPinRangeLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938v2.074c3.946.092 7 .723 7 1.488 0 .828-3.582 1.5-8 1.5s-8-.672-8-1.5c0-.765 3.054-1.396 7-1.488v-2.074zM12 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm0-4a2 2 0 1 1 0-4 2 2 0 0 1 0 4z' })
  );
};

var MapPinRangeLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(MapPinRangeLineIcon) : MapPinRangeLineIcon;

module.exports = MapPinRangeLineIcon$1;


/***/ }),

/***/ 97367:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var Search2LineIcon = function Search2LineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M11 2c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9zm0 16c3.867 0 7-3.133 7-7 0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7zm8.485.071l2.829 2.828-1.415 1.415-2.828-2.829 1.414-1.414z' })
  );
};

var Search2LineIcon$1 = React__default['default'].memo ? React__default['default'].memo(Search2LineIcon) : Search2LineIcon;

module.exports = Search2LineIcon$1;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3909,7966,5952,9774,2888,179], function() { return __webpack_exec__(25456); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);